import type { Api as RevealApi, Plugin as RevealPlugin } from 'reveal.js';
import { defineRevealGoban } from './define.js';

export { RevealGobanElement } from './element.js';
export type { RevealGobanMoveEventDetail, RevealGobanNavigateEventDetail, RevealGobanHoverEventDetail } from './element.js';
export { defineRevealGoban, REVEAL_GOBAN_TAG_NAME } from './define.js';
export { parseSgf } from './sgf.js';
export type { SgfData, SgfMove, SgfSetupStone, Color, Marker, MarkerType } from './sgf.js';
export type { GameNode, BoardState } from './engine.js';

// Importing this package registers <reveal-goban> as a side effect, matching
// how most custom-element libraries behave (`import 'reveal-goban'`
// just works). Call `defineRevealGoban()` yourself if you need to defer
// or control registration explicitly instead.
defineRevealGoban();

/**
 * reveal.js plugin for `<reveal-goban>`.
 *
 * @example
 * import RevealGoban from 'reveal-goban';
 * Reveal.initialize({ plugins: [RevealGoban] });*
 */
const RevealGobanPlugin: RevealPlugin = {
  id: 'reveal-goban',
  init(reveal: RevealApi): void {
    // Unlike a DOM-scanning approach, `<reveal-goban>` upgrades itself the
    // instant it's inserted into the document — including by the markdown
    // plugin's async rendering — so this plugin's only job is to re-run
    // Reveal's layout once the deck is ready, so slide sizing accounts for the
    // board. (Registration already happened above, as an import side effect.)
    reveal.on('ready', () => {
      reveal.layout();
    });
  }
};

export default RevealGobanPlugin;
